// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#mstar-style-body[data-v-26219d9a] {
  margin-bottom: 15px;
}
#mstar-style-body .morningstar-style-box-label[data-v-26219d9a] {
  position: relative;
  height: 110px;
  width: 110px;
}
#mstar-style-body .morningstar-style-box[data-v-26219d9a] {
  position: absolute;
  height: 80px;
  width: 80px;
  bottom: 33px;
}
#mstar-style-body .table-data[data-v-26219d9a] {
  list-style: none;
  padding-left: 0px;
  font-size: 14px;
  color: #333;
  font-family: "AvenirNextLTW01-Regular", Arial;
  line-height: 18px;
}
#mstar-style-body .table-data li[data-v-26219d9a] {
  margin-top: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/MorningstarStyle.vue","webpack://./MorningstarStyle.vue"],"names":[],"mappings":"AACA;EACC,mBAAA;ACAD;ADDA;EAIE,kBAAA;EACA,aAAA;EACA,YAAA;ACAF;ADNA;EAUE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;ACDF;ADZA;EAiBE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,6CAAA;EACA,iBAAA;ACFF;ADpBA;EAyBG,gBAAA;ACFH","sourcesContent":["\n#mstar-style-body {\n\tmargin-bottom: 15px;\n\n\t.morningstar-style-box-label {\n\t\tposition: relative;\n\t\theight: 110px;\n\t\twidth: 110px;\n\t}\n\n\t.morningstar-style-box {\n\t\tposition: absolute;\n\t\theight: 80px;\n\t\twidth: 80px;\n\t\tbottom: 33px;\n\t}\n\n\t.table-data {\n\t\tlist-style: none;\n\t\tpadding-left: 0px;\n\t\tfont-size: 14px;\n\t\tcolor: #333;\n\t\tfont-family: \"AvenirNextLTW01-Regular\", Arial;\n\t\tline-height: 18px;\n\n\t\tli {\n\t\t\tmargin-top: 13px;\n\t\t}\n\t}\n}\n","#mstar-style-body {\n  margin-bottom: 15px;\n}\n#mstar-style-body .morningstar-style-box-label {\n  position: relative;\n  height: 110px;\n  width: 110px;\n}\n#mstar-style-body .morningstar-style-box {\n  position: absolute;\n  height: 80px;\n  width: 80px;\n  bottom: 33px;\n}\n#mstar-style-body .table-data {\n  list-style: none;\n  padding-left: 0px;\n  font-size: 14px;\n  color: #333;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  line-height: 18px;\n}\n#mstar-style-body .table-data li {\n  margin-top: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
